export const VALIDATION_ERROR = {
  REQUIRED: 'required',
  EMAIL: 'email',
  MIN_LENGTH: 'minlength',
  MAX_LENGTH: 'maxlength',
  MIN_VALUE: 'minError',
  MIN_VALUE2: 'min',
  MAX_VALUE: 'maxError',
  MAX_VALUE2: 'max',
  PHONE: 'phone',
  PUBLIC_DOMAIN: 'publicDomain',
  ONLY_LETTERS: 'isOnlyLetters',
  ONLY_LETTERS_WITH_SPACES: 'isOnlyLettersWithSpace',
  ONLY_LETTERS_AND_NUMBERS: 'isOnlyLettersAndNumbers',
  WEBSITE: 'website',
  DATE_MORE_THEN: 'dateMoreThen',
  DATE_LESS_THEN: 'dateLessThen',
  DATE_RANGE_OVERLAP: 'dateRangeOverlap',
  ONLY_NUMBERS: 'onlyNumbers',
  ONE_REQUIRED: 'oneRequired',
  UNIQUE: 'unique',
  UNIQUE_NAME: 'uniqueName',
  UNIQUE_EMAIL: 'uniqueEmail',
  UNIQUE_LABELER_ID: 'uniqueLabelerId',
  PATTERN: 'pattern',
  UNIQUE_YEAR: 'uniqueYear',
  NOT_FOUND: 'notFound',
  NO_MESSAGE: 'noMessage'
} as const;
